
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Charge,
  ChargeDetailEntity,
} from "@/script/apps/inspect/entity/InspectEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { ChargeService } from "@/script/apps/inspect/service/ChargeService";
import { ElMessage, ElMessageBox } from "element-plus";

@Options({})
export default class ChargeDetail extends BaseDetail {
  private service = new ChargeService();

  protected selectedList: ChargeDetailEntity[] = [];

  private change = false;

  private error: string | null = null;

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_ins_charge",
      "/ins/charge",
      "/ins/charge",
      this.service
    );
    data.entity = {
      inspect: { code: "", name: "" },
    };
    data.statesName = "ins-charge-state";
    return data;
  }

  private rules = {
    code: [{ required: true, message: "请输入收费单号", trigger: "blur" }],
    name: [{ required: true, message: "请输入收费单名称", trigger: "blur" }],
  };

  public newEntity() {
    const entity: Charge = {};
    return entity;
  }

  public afterLoad() {
    this.change = false;
    const charge = this.entity as Charge;
    charge.deleteChargeDetails = [];
    this.injectDetailData(charge.chargeDetails!, charge.deleteChargeDetails);
    this.generateRowNo();
  }

  private audit() {
    const charge = this.entity as Charge;
    if (charge.chargeDetails) {
      const errors: string[] = [];
      charge.chargeDetails.forEach((item) => {
        if (item.type === "2") {
          const value =
            item.serviceMoney!.toString().replace(/\D/g, "") === ""
              ? 0
              : item.serviceMoney!;
          if (value <= 0) {
            errors.push(`第 [${item.no}] 行的 [服务费用] 不能为0！`);
          }
        }
      });

      if (errors.length > 0) {
        this.error = errors.join("");
        ElMessage.error(`审核失败!`);
        return false;
      } else {
        this.error = null;
      }
    }

    ElMessageBox.confirm("此操作将[审核订单], 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.service.audit(
          charge,
          (data: any) => {
            ElMessage({ type: "success", message: data.message });
            this.load(this.id);
          },
          function (error: Error) {
            ElMessage.error(error.message);
          }
        );
      })
      .catch(() => {
        ElMessage({
          type: "info",
          message: "已取消操作",
        });
      });
  }

  calculateSum() {
    const charge = this.entity as Charge;
    this.service.calculateSum(charge, (result: Charge) => {
      charge.testMoney = result.testMoney;
      charge.serviceMoney = result.serviceMoney;
      charge.totalMoney = result.totalMoney;
      this.change = false;
      ElMessage.success("计算完成");
    });
  }

  handleSelectionChange(val: any) {
    this.selectedList = val;
  }

  exceedChange(data: ChargeDetailEntity) {
    this.service.calculateItem(data, (result: ChargeDetailEntity) => {
      data.actualTestMoney = result.actualTestMoney;
      data.serviceMoney = result.serviceMoney;
      data.flag = "M";
      this.change = true;
      ElMessage.success("重新计算完成");
    });
  }

  serviceMoneyInput(data: ChargeDetailEntity) {
    this.change = true;
  }

  merge() {
    if (this.selectedList.length === 0) {
      ElMessage.error("请选择要合并的数据行！");
      return;
    }
    if (this.selectedList.length === 1) {
      ElMessage.error("不能选择1行数据合并！");
      return;
    }
    const firstName = this.selectedList[0].inspectDetail!.name;
    const firstPlanTestMoney = this.selectedList[0].planTestMoney;

    let check = true;
    this.selectedList.forEach((item) => {
      if (item.inspectDetail!.name !== firstName) {
        ElMessage.error("仪器名称不一致，不能合并！");
        check = false;
        return false;
      }
      if (item.planTestMoney !== firstPlanTestMoney) {
        ElMessage.error("检测费用不一致，不能合并！");
        check = false;
        return false;
      }
    });
    if (!check) {
      return;
    }

    const firstDetail = this.selectedList[0];
    const firstId = firstDetail.id;
    let factoryNumbers = firstDetail.factoryNumbers
      ? firstDetail.factoryNumbers
      : "";
    this.selectedList.forEach((item) => {
      factoryNumbers += "," + item.inspectDetail?.factoryNumber;
      if (item.id !== firstId) {
        firstDetail.quantity = firstDetail.quantity! + item.quantity!;
        item.flag = "D";
        this.deleteRowList.push(item);
      }
    });

    this.service.calculateItem(firstDetail, (result: ChargeDetailEntity) => {
      firstDetail.actualTestMoney = result.actualTestMoney;
      firstDetail.serviceMoney = result.serviceMoney;
      firstDetail.factoryNumbers = factoryNumbers.substring(1);
      firstDetail.flag = "M";

      const charge = this.entity as Charge;
      const newList: ChargeDetailEntity[] = [];
      charge.chargeDetails!.forEach((item) => {
        if (item.flag !== "D") {
          newList.push(item);
        }
      });
      charge.chargeDetails = newList;
      this.rowList = charge.chargeDetails;
      super.generateRowNo();
      (this.$refs.tableCharge as any).clearSelection();
      ElMessage.success("合并完成");
    });
  }
}
